import { render, staticRenderFns } from "./FieldVertical.vue?vue&type=template&id=7b0244a2&scoped=true&"
import script from "./FieldVertical.vue?vue&type=script&lang=js&"
export * from "./FieldVertical.vue?vue&type=script&lang=js&"
import style0 from "./FieldVertical.vue?vue&type=style&index=0&id=7b0244a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0244a2",
  null
  
)

export default component.exports